export default "__VITE_ASSET__DJMPyB7c__"